import { translate } from '@avalara/bat-apps-shared/i18n';
import { SDialog, SLoader } from '@avalara/skylab-sdk/react';

import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { useHistory } from 'react-router-dom';
import { useAppDispatch } from '../../hooks/use-app-dispatch';
import { pollForDeliverySystem } from '../../lib/side-effects/polling';
import { selectState } from '../../selectors';

const PollingDialog = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const {
    offer: { deliverySystemToPollFor, provisioningDelayed },
    system: { provisioningStatusId },
  } = useSelector(selectState);

  // biome-ignore lint/correctness/useExhaustiveDependencies: leaving as is
  useEffect(() => {
    if (!deliverySystemToPollFor || !provisioningStatusId) return;
    dispatch(pollForDeliverySystem(deliverySystemToPollFor, history, provisioningStatusId));
  }, [deliverySystemToPollFor, provisioningStatusId]);

  if (!deliverySystemToPollFor || !provisioningStatusId) return null;

  const title = "We're processing your purchase";
  const body = "This may take up to a minute. After that, you'll start your registrations.";

  const delayedTitle = 'This is taking longer than usual';
  const delayedBody = (
    <>
      {translate('client.general.stay-on-the-page-and-if-problem-doesnt-resolve-contact-us', {
        contactLink: (chunks) => <a href='mailto:asbeuropecompliance@avalara.com'>{chunks}</a>,
      })}
    </>
  );

  return (
    <SDialog data-ref='polling-dialog' open={true} noDismiss={true}>
      <div slot='header'>
        {provisioningDelayed ? delayedTitle : title}
        <SLoader loading className='margin-left-sm margin-right-sm' />
      </div>

      <div slot='body' className='pad-bottom-md'>
        {provisioningDelayed ? delayedBody : body}
      </div>
    </SDialog>
  );
};

export default PollingDialog;
